export default {
    demo (contex) {
        console.log('llamando action desde headerCore')
    }
}
